import React from 'react';

import {
  AnonymsView,
  ApiDocs,
  AppContainer,
  AuthCallback,
  Dashboard,
  Disclaimer,
  EmptyStub,
  Login,
  MainContainer,
  MainView,
  MembersList,
  NotFoundPage,
  TenantList,
  PrivacyPolicy,
  ResetPassword,
  Settings,
  TermsCondition,
  UserForgotPassword,
  UserProfile,
  UserRegister,
} from 'features';

import { Route } from 'third-party';

import {
  apiSpecUrl,
  appUrl,
  auditUrl,
  authCallbackUrl,
  disclaimerUrl,
  forgotPasswordUrl,
  loginUrl,
  memberListUrl,
  notFoundUrl,
  tenantDashboardUrl,
  tenantListUrl,
  privacyPolicyUrl,
  registerUrl,
  resetPasswordUrl,
  resetUserPasswordUrl,
  settingsUrl,
  termsAndConditionsUrl,
  userActivityListUrl,
  userFormUrl,
  userProfileUrl,
} from 'constants/url';

import { AuditsList } from 'features/Audit/AuditList';

export const useRoutes = () => {
  return (
    <Route path={appUrl()} element={<MainContainer />}>
      {/* anonyms  routes */}
      <Route path={authCallbackUrl()} element={<AuthCallback />} />
      <Route path={resetPasswordUrl()} element={<AnonymsView />}>
        <Route
          path={resetUserPasswordUrl(':email', ':token')}
          element={<ResetPassword />}
        />
      </Route>

      <Route path={disclaimerUrl()} element={<AnonymsView />}>
        <Route path={disclaimerUrl()} element={<Disclaimer />} />
      </Route>
      <Route path={privacyPolicyUrl()} element={<AnonymsView />}>
        <Route path={privacyPolicyUrl()} element={<PrivacyPolicy />} />
      </Route>
      <Route path={termsAndConditionsUrl()} element={<AnonymsView />}>
        <Route path={termsAndConditionsUrl()} element={<TermsCondition />} />
      </Route>

      <Route path={appUrl()} element={<AppContainer />}>
        <Route path={userFormUrl()} element={<AnonymsView />}>
          <Route path={registerUrl()} element={<UserRegister />} />
          <Route path={forgotPasswordUrl()} element={<UserForgotPassword />} />
          <Route path={loginUrl()} element={<Login />} />
        </Route>

        <Route path={appUrl()} element={<MainView />}>
          {/* user routes */}
          <Route path={userProfileUrl()} element={<UserProfile />} />
          <Route path={tenantListUrl()} element={<TenantList />} />

          {/* tenant routes */}
          <Route path={userProfileUrl(':tenantId')} element={<UserProfile />} />
          <Route path={apiSpecUrl(':tenantId')} element={<ApiDocs />} />

          <Route path={auditUrl(':tenantId')} element={<AuditsList />} />

          <Route
            path={tenantDashboardUrl(':tenantId')}
            element={<Dashboard />}
          />

          <Route path={memberListUrl(':tenantId')} element={<MembersList />} />
          <Route
            path={userActivityListUrl(':tenantId')}
            element={<EmptyStub />}
          />
          <Route path={settingsUrl(':tenantId')} element={<Settings />} />
        </Route>
      </Route>

      <Route path={notFoundUrl()} element={<NotFoundPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Route>
  );
};
